import { Tooltip, Space, Image, Popconfirm } from "antd";
import { EditTwoTone, DeleteTwoTone } from "@ant-design/icons";
import get from "lodash/get";
import { COLOR_PRIMARY } from "..";
import { assign } from "lodash";

const templateTypeColumns = (type) => {
  let templateColumns = [];
  switch (type) {
    case 1:
      templateColumns = [
        {
          title: "Part Weight",
          dataIndex: ["meta", "part_weight"],
          key: "part_weight",
          align: "center",
          render: (text) => (text ? text : "--"),
        },
        {
          title: "Shot Weight",
          dataIndex: ["meta", "shot_weight"],
          key: "shot_weight",
          align: "center",
          render: (text) => (text ? text : "--"),
        },
        {
          title: "Cavity",
          dataIndex: ["meta", "cavity"],
          key: "cavity",
          align: "center",
          render: (text) => (text ? text : 0),
        },
        {
          title: "Cycle Time",
          dataIndex: ["meta", "cycle_time"],
          key: "cycle_time",
          align: "center",
          render: (val) => `${val} sec`,
        },
        {
          title: "Units / box",
          dataIndex: ["meta", "units_per_box"],
          key: "units_per_box",
          align: "center",
          render: (val) => (val ? val : 1),
        },
      ];
      break;
    case 2:
      templateColumns = [
        {
          title: "Weight/meter",
          dataIndex: ["meta", "part_weight"],
          key: "part_weight",
          align: "center",
          render: (text) => (text ? text : 0),
        },
        {
          title: "Machine speed",
          dataIndex: ["meta", "machine_speed"],
          key: "machine_speed",
          align: "center",
          render: (text) => (text ? text : 0),
        },
      ];
      break;
    case 3:
      templateColumns = [
        {
          title: "Press Cycle",
          dataIndex: ["meta", "press_cycle"],
          key: "press_cycle",
          align: "center",
          render: (text) => (text ? text : 1),
        },
        {
          title: "Part weight",
          dataIndex: ["meta", "part_weight"],
          key: "part_weight",
          align: "center",
          render: (text) => (text ? text : 0),
        },
        {
          title: "Units / box",
          dataIndex: ["meta", "units_per_box"],
          key: "units_per_box",
          align: "center",
          render: (val) => (val ? val : 1),
        },
      ];
      break;
    case 4:
      templateColumns = [
        {
          title: "No of operations",
          dataIndex: ["meta", "machining_cycle"],
          key: "machining_cycle",
          align: "center",
          render: (text) => (text ? text : 0),
        },
        {
          title: "Cycle time",
          dataIndex: ["meta", "cycle_time"],
          key: "cycle_time",
          align: "center",
          render: (text) => (text ? text : 0),
        },
        {
          title: "Raw weight",
          dataIndex: ["meta", "raw_weight"],
          key: "raw_weight",
          align: "center",
          render: (text) => (text ? text : 0),
        },
        {
          title: "Finished weight",
          dataIndex: ["meta", "finished_weight"],
          key: "finished_weight",
          align: "center",
          render: (text) => (text ? text : 0),
        },
        {
          title: "Units / box",
          dataIndex: ["meta", "units_per_box"],
          key: "units_per_box",
          align: "center",
          render: (val) => (val ? val : 1),
        },
      ];
      break;
  }
  return templateColumns;
};
export const partColumns = (onEdit, onDelete, type, isStaff) => [
  {
    title: "Image",
    key: "image",
    render: (record) => {
      return <Image width={40} src={get(record, "image.url")} />;
    },
  },
  {
    title: "Part",
    dataIndex: "name",
    key: "name",
  },
  ...templateTypeColumns(type),
  {
    title: "Action",
    key: "id",
    align: "center",
    render: (record) => {
      return (
        <Space size="middle">
          <Tooltip title="Edit Part">
            <EditTwoTone
              style={{ fontSize: 20 }}
              twoToneColor={COLOR_PRIMARY}
              onClick={() => {
                if (!get(record, "meta.costings")) {
                  assign(get(record, "meta"), {
                    costings: {
                      ...get(record, "meta"),
                      job_cost_per_pc: 0,
                      profit_per_pc: 0,
                      contractual_cost_per_pc: 0,
                    },
                  });
                }
                onEdit(record);
              }}
            />
          </Tooltip>
          {!isStaff && (
            <Popconfirm
              title="Delete the part"
              description="Are you sure to delete this part?"
              onConfirm={() => onDelete(record)}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Delete Part">
                <DeleteTwoTone
                  style={{ fontSize: 20 }}
                  twoToneColor={COLOR_PRIMARY}
                />
              </Tooltip>
            </Popconfirm>
          )}
        </Space>
      );
    },
  },
];
